<footer class="ap-footer ms-2">
  <div class="ap-footer-content">
    {{ 'footer.textStart' | translate: { year: currentYear } }}
    <a class="ap-link" href="https://www.pwc.com/structure" target="_blank"
      >www.pwc.com/structure</a
    >
    {{ 'footer.textEnd' | translate }}

    <button
      class="ap-link d-inline p-0 bg-transparent"
      (click)="clickDisclaimer()">
      {{ 'footer.here' | translate }}</button
    >.
  </div>
  <div class="ap-footer-link-group d-flex mt-3">
    @for (item of footerLinks; track $index; let last = $last) {
      <div class="ap-footer-link">
        <a class="ap-link" [href]="item.link" target="_blank">{{
          item.text | translate
        }}</a>
        @if (!last) {
          <span class="ap-footer-divider mx-3">|</span>
        }
      </div>
    }
  </div>
</footer>
